import React from 'react';
import {
	Box,
	Button,
	Stack,
	Tooltip,
	Typography,
	useTheme,
} from '@mui/material';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { surfaceCard } from '../../../../Shared/surfaceCard';

const DocumentButton = ({
	label,
	icon: Icon,
	url,
	disabledTooltip,
	fullWidth = false,
}) => (
	<Tooltip title={url ? `Open ${label.toLowerCase()} PDF` : disabledTooltip}>
		<span style={fullWidth ? { width: '100%' } : undefined}>
			<Button
				size="small"
				variant="outlined"
				color="inherit"
				disabled={!url}
				component={url ? 'a' : 'button'}
				href={url || undefined}
				target={url ? '_blank' : undefined}
				rel={url ? 'noopener noreferrer' : undefined}
				startIcon={<Icon sx={{ fontSize: 18 }} />}
				endIcon={url ? <OpenInNewIcon sx={{ fontSize: 16 }} /> : null}
				sx={{
					textTransform: 'none',
					fontWeight: 600,
					fontSize: '0.8rem',
					borderColor: 'divider',
					color: 'text.primary',
					width: fullWidth ? '100%' : 'auto',
					justifyContent: fullWidth ? 'flex-start' : 'center',
					'&:hover': url
						? {
								borderColor: 'primary.main',
								bgcolor: 'action.hover',
							}
						: undefined,
				}}
			>
				{label}
			</Button>
		</span>
	</Tooltip>
);

const JobDocuments = ({
	proposalPdfUrl,
	invoicePdfUrl,
	variant = 'inline',
}) => {
	const theme = useTheme();
	const isSidebar = variant === 'sidebar';

	const content = (
		<Stack
			direction={isSidebar ? 'column' : 'row'}
			spacing={1}
			sx={{ width: isSidebar ? '100%' : 'auto' }}
		>
			<DocumentButton
				label="View proposal"
				icon={DescriptionOutlinedIcon}
				url={proposalPdfUrl}
				disabledTooltip="Send the proposal first"
				fullWidth={isSidebar}
			/>
			<DocumentButton
				label="View invoice"
				icon={ReceiptLongOutlinedIcon}
				url={invoicePdfUrl}
				disabledTooltip="Send an invoice first"
				fullWidth={isSidebar}
			/>
		</Stack>
	);

	if (isSidebar) {
		return (
			<Box sx={{ ...surfaceCard(theme), p: 2.5 }}>
				<Typography
					variant="caption"
					sx={{
						display: 'block',
						fontWeight: 700,
						color: 'text.secondary',
						textTransform: 'uppercase',
						letterSpacing: 0.8,
						fontSize: '0.65rem',
						mb: 1.5,
					}}
				>
					Documents
				</Typography>
				{content}
			</Box>
		);
	}

	return content;
};

export default JobDocuments;
